import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    tglStockOpname: Yup.string().required("Pilih tanggal"),
  });
